import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf5a13e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "d-flex align-items-center mb-5 gap-4" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-dot legend-dot-available me-2" }, null, -1))
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-dot legend-dot-registered me-2" }, null, -1))
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "legend-dot legend-dot-selected me-2" }, null, -1))
const _hoisted_10 = { class: "alert alert-light-info border border-info mb-8" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "mb-0 fw-bold" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 col-md-4 col-lg-3 mb-8" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "calendar-container border rounded p-4" }
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-left" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "fw-bold text-capitalize" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "calendar-grid" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-12 col-md-8 col-lg-9" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "table-responsive" }
const _hoisted_29 = { class: "table table-row-bordered table-row-gray-200 align-middle" }
const _hoisted_30 = { class: "fw-bold text-muted" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = ["title", "onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen-to-square" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["title", "onClick"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-times" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 2,
  class: "badge badge-light-secondary"
}
const _hoisted_40 = {
  key: 1,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_41 = { class: "text-muted fs-5" }
const _hoisted_42 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_43 = { class: "mb-5" }
const _hoisted_44 = { class: "table-responsive" }
const _hoisted_45 = { class: "table table-row-bordered table-row-gray-200 align-middle" }
const _hoisted_46 = { class: "fw-bold text-muted" }
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = { class: "text-center" }
const _hoisted_49 = ["title", "onClick"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-times" }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicCard = _resolveComponent("BasicCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BasicCard, { title: _ctx.pageTitle }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('views.portal.ateliers.legend.available')), 1)
            ]),
            _createElementVNode("span", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('views.portal.ateliers.legend.registered')), 1)
            ]),
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('views.portal.ateliers.legend.selectedDay')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('views.portal.ateliers.description')), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('views.portal.ateliers.cancellationNotice')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.$t('views.portal.ateliers.availableSessions')), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-icon btn-light",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevMonth && _ctx.prevMonth(...args)))
                  }, _hoisted_19),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.currentMonthLabel), 1),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-icon btn-light",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
                  }, _hoisted_22)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "calendar-header",
                      key: day
                    }, _toDisplayString(day), 1))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calendarCells, (cell, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: _normalizeClass(["calendar-cell", {
                    'calendar-cell-empty': !cell.day,
                    'calendar-cell-selected': cell.isSelected,
                    'calendar-cell-has-ateliers': cell.hasAteliers && !cell.hasRegistered,
                    'calendar-cell-has-registered': cell.hasRegistered,
                    'calendar-cell-clickable': cell.day && cell.hasAteliers
                  }]),
                      onClick: ($event: any) => (cell.day && cell.hasAteliers && _ctx.selectDate(cell.dateStr))
                    }, [
                      (cell.day)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(cell.day), 1))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_24))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              (_ctx.filteredAteliers.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("table", _hoisted_29, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_30, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.type')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.description')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.date')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.time')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.duration')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.modality')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.location')), 1),
                            _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t('views.portal.ateliers.table.actions')), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAteliers, (atelier) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: atelier.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(atelier.intitule || _ctx.getTypeLabel(atelier.type)), 1),
                              _createElementVNode("td", null, _toDisplayString(atelier.description || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDateShort(atelier.dateDebut)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(atelier.dateDebut)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getDuration(atelier)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.getModaliteLabel(atelier.modalite)), 1),
                              _createElementVNode("td", null, _toDisplayString(atelier.emplacement || '-'), 1),
                              _createElementVNode("td", _hoisted_32, [
                                (!Number(atelier.isInscrit) && _ctx.canRegisterToAtelier(atelier))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn btn-sm btn-icon btn-success",
                                      title: _ctx.$t('views.portal.ateliers.registerBtn'),
                                      onClick: ($event: any) => (_ctx.registerAtelier(atelier))
                                    }, _hoisted_35, 8, _hoisted_33))
                                  : (Number(atelier.isInscrit) >= 1)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn btn-sm btn-icon btn-danger",
                                        title: _ctx.$t('views.portal.ateliers.unregisterBtn'),
                                        onClick: ($event: any) => (_ctx.unregisterAtelier(atelier))
                                      }, _hoisted_38, 8, _hoisted_36))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('views.portal.ateliers.full')), 1))
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t('views.portal.ateliers.noSessions')), 1)
                  ]))
            ])
          ]),
          (_ctx.registeredAteliers.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.$t('views.portal.home.myAteliersTitle')), 1),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("table", _hoisted_45, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_46, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.type')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.description')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.date')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.time')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.duration')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.modality')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('views.portal.ateliers.table.location')), 1),
                        _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.$t('views.portal.ateliers.table.actions')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.registeredAteliers, (atelier) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: atelier.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(atelier.intitule || _ctx.getTypeLabel(atelier.type)), 1),
                          _createElementVNode("td", null, _toDisplayString(atelier.description || '-'), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDateShort(atelier.dateDebut)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(atelier.dateDebut)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getDuration(atelier)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.getModaliteLabel(atelier.modalite)), 1),
                          _createElementVNode("td", null, _toDisplayString(atelier.emplacement || '-'), 1),
                          _createElementVNode("td", _hoisted_48, [
                            _createElementVNode("button", {
                              class: "btn btn-sm btn-icon btn-danger",
                              title: _ctx.$t('views.portal.ateliers.unregisterBtn'),
                              onClick: ($event: any) => (_ctx.unregisterAtelier(atelier))
                            }, _hoisted_51, 8, _hoisted_49)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ]))
}